<template>
  <div class="panel" :style="style">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Panel',

  props: {
    z: {
      type: [ String, undefined ],
      default: undefined
    },

    top: {
      type: [ Number, String, undefined ],
      default: undefined
    },

    left: {
      type: [ Number, String, undefined ],
      default: undefined
    },

    right: {
      type: [ Number, String, undefined ],
      default: undefined
    },

    bottom: {
      type: [ Number, String, undefined ],
      default: undefined
    },

    width: {
      type: [ Number, String ],
      default: 'auto'
    },

    height: {
      type: [ Number, String ],
      default: 'auto'
    },

    padding: {
      type: [ Number, String ],
      default: 0
    },

    margin: {
      type: [ Number, String ],
      default: 0
    },

    position: {
      type: [ String, undefined ],
      default: 'relative'
    }
  },

  computed: {
    style () {
      let {
        z,
        top,
        left,
        right,
        bottom,
        width,
        height,
        margin,
        padding,
        position
      } = this

      if (typeof top === 'number') top += 'px'
      if (typeof left === 'number') left += 'px'
      if (typeof right === 'number') right += 'px'
      if (typeof bottom === 'number') bottom += 'px'
      if (typeof width === 'number') width += 'px'
      if (typeof height === 'number') height += 'px'
      if (typeof margin === 'number') margin += 'px'
      if (typeof padding === 'number') padding += 'px'

      return {
        top: top || 'auto',
        left: left || 'auto',
        right: right || 'auto',
        bottom: bottom || 'auto',
        width,
        height,
        margin,
        padding,
        position,
        zIndex: z || 'initial'
      }
    }
  }
}
</script>
